import styled from 'styled-components'

export const ReferralTableListSection = styled.div`
	width: 100%;
	height: 80%;
	display: flex;
	flex-direction: column;
`
